import { ControlBase } from './control-base';

export class MetadataTextbox extends ControlBase<string> {
    override controlType = 'text';
}
